import { ShieldCheck } from "lucide-react";

export function VeteranBanner() {
  return (
    <div
      className="bg-slate-900 text-white text-center text-xs sm:text-sm font-semibold tracking-wide py-2.5 px-4 flex items-center justify-center gap-2"
      data-testid="veteran-top-banner"
    >
      <ShieldCheck className="w-4 h-4 text-amber-400 shrink-0" />
      <span>
        100% Veteran-Owned &amp; Operated —{" "}
        <span className="text-amber-400">15% OFF</span> your first cleaning for Vets &amp; First Responders
      </span>
    </div>
  );
}
